// extracted by mini-css-extract-plugin
module.exports = {"lever":"lever--3THdr","filled-in":"filled-in--fQ3IU","tabbed":"tabbed--13KCP","switchInput":"switchInput--wYOTF"};